module.exports = __webpack_public_path__ + "img/SKMJ_rights.e2830a2d.png";